import React, { useState } from "react";
import farmer from "../../assets/farmer.png";

const Tooltip: React.FC = () => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  return (
    <div className="relative">
      <div className=" fixed inset-y-0 left-0 max-lg:hidden flex justify-center items-center">
        <div
          className="relative w-70 h-70 bg-cover"
          style={{ backgroundImage: `url(${farmer})` }}
          onMouseEnter={() => setTooltipIsOpen(true)}
          onMouseLeave={() => setTooltipIsOpen(false)}
        >
          <div
            className={`${
              tooltipIsOpen ? "block" : "hidden"
            } absolute bottom-48 right-0 transform bg-gray-800 text-white px-4 py-2 rounded-md z-10 w-60`}
          >
            Hey, I'm farmer Chad. Take actions on L2s with me, check FAQ and
            let's go MINT.
            <button
              className="text-blue-500 ml-2"
              onClick={() => setTooltipIsOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
